import Udesk from 'Udesk';
import React from 'react';
import CallManageDetailRoute from './route';
import { Layout, PageHeader } from 'udesk-ui';
import MiniListManage from '../../components/mini-list-manage-info';
import RecordDetail from '../../components/record-detail';
import './style.scss';

export default class CallManageDetailTemplate extends CallManageDetailRoute {
    render() {
        let {
            pageConfig,
            selectedDatum,
            selectedFilter,
            layoutSiderRef,
            collapsed,
            scrollFlag,
            manageRef,
        } = this.privates;

        let { actions, locales } = this;

        const siderAction = (
            <div className="layout-menu-pages-sider-actions-arrow">
                <i class="udesk-qa-react-web-iconfont icon-udesk-qa-react-web-zhankaitixing"></i>
                {!collapsed ? (
                    <i class="udesk-qa-react-web-iconfont icon-udesk-qa-react-web-ic-arrow-left-s-line"></i>
                ) : (
                    <i class="udesk-qa-react-web-iconfont icon-udesk-qa-react-web-ic-arrow-right-s-youjiantou"></i>
                )}
            </div>
        );

        return (
            <div className="layout-menu-pages">
                <Layout style={{ height: '100%' }}>
                    <Layout.Sider
                        ref={layoutSiderRef}
                        collapsed={collapsed}
                        width={260}
                        collapsedWidth={1}
                        collapsible
                        className="layout-menu-pages-sider"
                        onCollapse={actions.siderActionsChange}
                        trigger={siderAction}
                    >
                        <MiniListManage
                            manageTitle={locales.components.pages.callManage.listTitle}
                            pageConfig={pageConfig}
                            selectedDatum={selectedDatum}
                            onSelectedDatumChanged={actions.changeSelectedDatum}
                            selectedFilter={selectedFilter}
                            type={Udesk.enums.filterTypes.call.id}
                            onBackToIndex={actions.backToIndexPage}
                            onPageChanged={actions.onPageChanged}
                            getPageConfig={actions.getPageConfig}
                        />
                    </Layout.Sider>

                    <Layout.Content style={{ background: 'rgba(240,242,245,1)' }}>
                        <div className="udesk-qa-web-page">
                            <PageHeader
                                className="udesk-qa-web-page-header"
                                onBack={actions.backToIndexPage}
                                title={locales.components.pages.callManage.detailTitle}
                            />
                            <div
                                className="udesk-qa-web-page-body"
                                onScrollCapture={actions.handleScroll}
                                ref={manageRef}
                            >
                                <div className="udesk-qa-web-page-body-root">
                                    <RecordDetail
                                        scrollFlag={scrollFlag}
                                        keywords={selectedFilter.keyword}
                                        keywordType={selectedFilter.keywordType}
                                        selectedDatum={selectedDatum}
                                        onTransitionToTemplate={actions.transitionToTemplate}
                                        inspectDataSource={
                                            Udesk.enums.inspectDataSources.voiceCall.id
                                        }
                                        onSeriesClicked={actions.transitionToSentimentAnalysis}
                                    />
                                </div>
                            </div>
                        </div>
                    </Layout.Content>
                </Layout>
            </div>
            // <div className='udesk-qa-web-page-body-root call-manage-detail-page'>
            //     <div className="qa-react-page-left-part call-manage-detail-page-left-part col-md-2 col-sm-3 col-xs-12">

            //     </div>
            //     <div className="qa-react-page-right-part call-manage-detail-page-right-part col-md-10 col-sm-9 col-xs-12">
            //         <div className="qa-react-call-manage-detail-title">
            //             <span className="qa-react-call-manage-detail-span" onClick={actions.backToIndexPage}>
            //                 <i className="udesk-qa-react-web-iconfont icon-udesk-qa-react-web-jiantou2"></i>
            //                 {locales.components.pages.callManage.detailTitle}
            //             </span>
            //         </div>
            //     </div>
            // </div>
        );
    }
}
